// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"394":"48a86b7d","1897":"48a86b7d","4176":"f74e5992","4216":"e0a92e65"}[chunkId] + ".chunk.css";
};